var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGamesNearbyHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finder-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.9978C0 26.3703 7.62531 33.9956 16.9978 33.9956C26.3703 33.9956 33.9956 26.3703 33.9956 16.9978C33.9956 7.62531 26.3703 0 16.9978 0C7.62531 0 0 7.62531 0 16.9978ZM2.10025 16.9978C2.10025 8.78342 8.78342 2.10025 16.9978 2.10025C25.2121 2.10025 31.8953 8.78342 31.8953 16.9978C31.8953 25.2126 25.2121 31.8953 16.9978 31.8953C8.78342 31.8953 2.10025 25.2126 2.10025 16.9978Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9893 19.2543C11.0091 19.2561 11.0289 19.257 11.0482 19.257C11.3044 19.257 11.535 19.1042 11.6344 18.8682L19.2066 0.883758C19.3072 0.644613 19.2533 0.370405 19.0704 0.18745C18.9494 0.0669786 18.7889 0 18.619 0C18.5345 0 18.4527 0.0170818 18.374 0.0503463L0.389613 7.62252C0.132937 7.73041 -0.022148 7.98933 0.00257563 8.26624C0.0272993 8.54314 0.226887 8.76925 0.498397 8.82994L8.42929 10.5925C8.54707 10.6186 8.63922 10.7103 8.66529 10.8285L10.427 18.759C10.4876 19.0305 10.7142 19.2292 10.9893 19.2543ZM16.0119 2.88375C16.0463 2.86897 16.083 2.86178 16.119 2.86178C16.1909 2.86178 16.2613 2.88975 16.3144 2.9429C16.3935 3.02202 16.4171 3.1419 16.3736 3.2454L11.4679 14.8965C11.4243 14.9996 11.3236 15.0656 11.2133 15.0656C11.2054 15.0656 11.197 15.0652 11.1886 15.0644C11.0687 15.054 10.97 14.9669 10.9436 14.8494L9.83348 9.85381C9.78593 9.64001 9.61689 9.47138 9.4039 9.42382L4.40753 8.3137C4.29005 8.28732 4.20333 8.18822 4.19254 8.06874C4.18175 7.94885 4.24969 7.83576 4.36038 7.78941L16.0119 2.88375Z",
    transform: "translate(5.810007 8.928393)",
    id: "Fill-4",
    fill: "#3E9DE5",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamesNearbyHeaderIcon);
export default __webpack_public_path__ + "static/media/games-nearby-header-icon.adfcad089f9cab6f0bdb5404b740ccd4.svg";
export { ForwardRef as ReactComponent };